import { render, staticRenderFns } from "./ReprocessingButton.vue?vue&type=template&id=2263fb7a&scoped=true"
import script from "./ReprocessingButton.vue?vue&type=script&lang=js"
export * from "./ReprocessingButton.vue?vue&type=script&lang=js"
import style0 from "./ReprocessingButton.vue?vue&type=style&index=0&id=2263fb7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2263fb7a",
  null
  
)

export default component.exports